u_FormatMoney = (cents, format) => {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  var match = formatString.match(placeholderRegex);

  if (match) {
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
};

document.addEventListener('alpine:init', () => {
  Alpine.data('SubscriptionWidget', () => ({
    money_format: '${{amount}}',
    product: null,
    selected_variant: null,
    selling_plans: [],
    selected: {
      purchase_type: 'subscribe', // 'one-time' or 'subscribe'
      frequency: '',
      plan: null,
      plan_index: 0,
      quantity: 1,
      variant: null
    },
    flags: {
      initialize: true
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.money_format = this.$el.dataset.money_format;
      let product = JSON.parse(this.$el.dataset.product);
      this.product = product;
      // console.log(product);
      this.selected_variant = JSON.parse(this.$el.dataset.selected_variant);
      this.selected.variant = this.selected_variant;
    },
    InitWatchers() {
      // Listen to selected variant to update selling plans
      this.$watch('selected_variant', () => {
        this.selected.quantity = 1;
        this.selected.variant = this.selected_variant;
        this.SetSellingPlans();
      });

      // Listen to plan index to update selected plan
      this.$watch('selected.plan_index', () => {
        this.SetSellingPlans();
      });

      // Listen to variant change event to update selected_variant
      subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        // console.log(e);
        this.selected_variant = e.data.variant;
      });

      // listen for subscription change, and update form selling_plan
      this.$watch('selected.purchase_type', this.UpdateProductFormSellingPlan.bind(this));
      this.$watch('selected.plan', this.UpdateProductFormSellingPlan.bind(this));

      // Cleanup on widget removal
      document.addEventListener('widget:cleanup', () => {
        this.flags.initialize = false;
      });
    },
    UpdateProductFormSellingPlan() {
      let $product = this.$el.closest('.product__info-wrapper');
      let $selling_plan_input = $product.querySelector("[name=selling_plan]");
      let selling_plan_id = this.selected.purchase_type === 'subscribe' ? this.selected.plan.id : '';
      if ($selling_plan_input) {
        $selling_plan_input.value = selling_plan_id;
      }
      else {
        let $form = $product.querySelector('.product-form form');
        $form.insertAdjacentHTML('beforeend', `<input type="hidden" name="selling_plan" value="${selling_plan_id}">`);
      }
    },
    SetSellingPlans() {
      let pack_index = this.selected_variant.title.indexOf('12') > -1 ? 0 : 1;

      let selling_plans = this.product.selling_plan_groups[pack_index].selling_plans;

      this.selling_plans = selling_plans;
      this.selected.plan = selling_plans[this.selected.plan_index];
      this.selected.frequency = this.selected.plan.selling_plan_id;
    },
    GetSubscriptionPrice() {
      if (!this.selected.plan) return this.selected_variant.price;
      let percent = this.selected.plan.price_adjustments.find(item => item.value_type == 'percentage').value;
      return this.selected_variant.price * (1 - percent / 100);
    },
    GetSubscriptionPercentage() {
      if (!this.selected.plan) return 0;
      let percent = this.selected.plan.price_adjustments.find(item => item.value_type == 'percentage').value;
      // if 24 pack, show 20%
      if (this.selected_variant.title.indexOf('24-') > -1) {
        percent = 20;
      }
      return `${percent}%`;
    },
    u_FormatMoney(value) {
      return u_FormatMoney(value, this.money_format);
    }
  }));

  let latest_request = null;
  Alpine.data('SwitchProduct', () => ({
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      // Listen to variant change event to update selected_variant
      subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        // console.log(e);
        let option1 = e.data.variant.option1;
        let $product_links = this.$el.querySelectorAll('a[data-product]');
        $product_links.forEach($link => {
          let product = JSON.parse($link.dataset.product);
          let matching_variant = product.variants.find(v => v.option1 === option1);
          if (matching_variant) {
            $link.dataset.matching_variant = matching_variant.id;
          }
          else {
            $link.dataset.matching_variant = '';
          }
        });
      });
    },
    async e_SwitchProduct(e) {
      // console.log(e);
      let $link = this.$el;
      let section_id = $link.dataset.sectionId;
      let product_handle = $link.dataset.productHandle;

      // Debounce multiple requests
      await new Promise((resolve) => setTimeout(resolve, 300));
      if (latest_request == product_handle) return;

      latest_request = product_handle;
      let url = `/products/${product_handle}?section_id=${section_id}`;
      let matching_variant_id = $link.dataset.matching_variant;
      if (matching_variant_id) {
        url += `&variant=${matching_variant_id}`;
      }
      let response = await fetch(url);
      let text = await response.text();
      let parser = new DOMParser();
      let doc = parser.parseFromString(text, 'text/html');
      let $new_section = doc.querySelector(`#shopify-section-${section_id}`);
      let $current_section = document.querySelector(`#shopify-section-${section_id}`);
      if ($new_section && $current_section) {
        document.dispatchEvent(new CustomEvent('widget:cleanup'));
        // Re-initialize Alpine components
        this.$nextTick(() => {
          $current_section.replaceWith($new_section);
          Alpine.initTree($new_section);
        });
      }
    }
  }));
});